import { render, staticRenderFns } from "./DisasterMgtTable.vue?vue&type=template&id=2bf071c0&scoped=true&"
import script from "./DisasterMgtTable.vue?vue&type=script&lang=js&"
export * from "./DisasterMgtTable.vue?vue&type=script&lang=js&"
import style0 from "./DisasterMgtTable.vue?vue&type=style&index=0&id=2bf071c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf071c0",
  null
  
)

export default component.exports